import { createColorKeys } from '~/utils/chakraUtils'

import { blockedNumbersColors } from './BlockedNumbers.colors'
import { callCenterSettingsColors } from './CallCenterSettings.colors'
import { phoneSettingsColors } from './PhoneSettings.colors'
import { profileSettingsColors } from './ProfileSettings.colors'
import { sharedSettingsStyleColors } from './Shared.colors'
import { snippetSettingsColors } from './SnippetSettings.colors'

// This is referenced in src/themes/colors/colors.ts
export const settingsColors = {
  Settings: {
    Profile: { ...profileSettingsColors },
    BlockedNumbers: { ...blockedNumbersColors },
    PhoneSettings: { ...phoneSettingsColors },
    Shared: { ...sharedSettingsStyleColors },
    SnippetSettings: { ...snippetSettingsColors },
    CallCenterSettings: { ...callCenterSettingsColors },
  },
}

export const settingsColorKeys = createColorKeys(settingsColors)
